import { render, staticRenderFns } from "./QualificationsRegistryNewForm.vue?vue&type=template&id=0671f0d8"
import script from "./QualificationsRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./QualificationsRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports